import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ManualPage() {
  const [activeTab, setActiveTab] = useState('admin');

  const tabs = [
    { id: 'admin', label: '管理者用', icon: 'ri-admin-line' },
    { id: 'place', label: '居場所・学習者用', icon: 'ri-home-4-line' },
    { id: 'volunteer', label: 'ボランティア用', icon: 'ri-user-heart-line' },
    { id: 'video', label: 'ビデオ通話用', icon: 'ri-video-line' },
    { id: 'notification', label: '通知設定', icon: 'ri-notification-line' }
  ];

  const adminFeatures = [
    {
      title: '概要タブ',
      description: '登録居場所数、総学習者数、配分済・配分可能ポイント、団体情報（メール／電話／住所）',
      icon: 'ri-dashboard-line'
    },
    {
      title: '居場所管理タブ',
      description: '新規登録／情報編集／ログイン情報変更／ログイン用QR表示／削除／保有ポイント・定員・学習者数の確認',
      icon: 'ri-building-line'
    },
    {
      title: 'ポイント管理タブ',
      description: '総残高と内訳／ポイント購入（Stripe）／返金申請／居場所への分配・回収／月次レポート閲覧・DL',
      icon: 'ri-coin-line'
    },
    {
      title: '設定タブ',
      description: '団体情報（法人名・メール・電話・住所）',
      icon: 'ri-settings-line'
    }
  ];

  const placeFeatures = [
    {
      title: '概要',
      description: '登録学習者数、進行中/完了セッション数、保有ポイント残高、債務残高、オンライン講師数',
      icon: 'ri-dashboard-line'
    },
    {
      title: '学習スタイル選択',
      description: '個別／グループ（複数オンライン参加）／クラス（1画面共有・1人のみオンライン）',
      icon: 'ri-group-line'
    },
    {
      title: '学習者管理',
      description: '新規追加、総/完了セッション数・総学習時間、進行中状態、個別学習画面へ遷移',
      icon: 'ri-user-line'
    },
    {
      title: '進行中のセッション管理',
      description: '状態確認／AI解析結果／課題アップロード／各メンバーの学習画面へ／キャンセル',
      icon: 'ri-live-line'
    }
  ];

  const volunteerFeatures = [
    {
      title: 'タイムラインボード',
      description: '時間帯別の依頼、科目/学年/難易度/推定時間のフィルタ、AI解析結果の閲覧、授業時間選択',
      icon: 'ri-calendar-line'
    },
    {
      title: '進行中のセッション',
      description: '承認済み一覧、予定時刻までのカウンドダウン、ビデオ通話開始（10分前から可）',
      icon: 'ri-video-line'
    },
    {
      title: '完了セッション',
      description: '履歴、個別コメント／グループ一括コメント、学習者のフィードバック・評価、獲得ポイントの確認',
      icon: 'ri-check-line'
    },
    {
      title: '統計・設定',
      description: '総指導時間、獲得ポイント総額、通知設定、稼働時間スケジュール、報酬申請（ポイント換金）',
      icon: 'ri-bar-chart-line'
    }
  ];

  const adminSteps = [
    '管理者でログイン→ダッシュボードで残高と配分可能ポイントを確認',
    'ポイント管理→必要に応じて購入。内訳（購入/寄付/キャンペーン）を把握',
    '居場所管理→新規登録や編集。ログインQRを発行し配布',
    'ポイント管理→居場所へ配分（誤配分時は回収）',
    '月次締め→ポイント台帳／月次レポートをDLし会計へ連携'
  ];

  const placeSteps = [
    'ログイン→概要で残高とオンライン講師数を確認',
    '学習スタイルを選択し、対象学習者をチェック',
    '課題画像をアップロード→AI解析結果（科目/難易度/推定時間）を確認',
    '指導者からの提案通知を受信→内容を比較し承認',
    'ビデオ通話を実施→終了後に学習報告書を作成・保存'
  ];

  const volunteerSteps = [
    'ログイン→稼働スケジュールを設定（通知最適化）',
    'タイムラインで案件を確認→条件でフィルタ→提案を送信',
    '承認後、予定に合わせビデオ通話開始（10分前から可）',
    '終了後にコメントを記録。必要に応じポイント換金を申請'
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'admin':
        return (
          <div className="space-y-12">
            {/* 目的・役割 */}
            <div className="bg-blue-50 rounded-2xl p-8 border border-blue-200">
              <h3 className="text-xl font-bold text-blue-900 mb-4">目的・主な役割</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-blue-800 mb-2">目的</h4>
                  <p className="text-blue-700">傘下の居場所を統括し、ポイントの購入・配分や会計連携を行う</p>
                </div>
                <div>
                  <h4 className="font-semibold text-blue-800 mb-2">主な役割</h4>
                  <ul className="text-blue-700 space-y-1">
                    <li>• 複数の居場所の一元管理</li>
                    <li>• ポイント購入・配分・回収、月次レポート確認</li>
                    <li>• 居場所の登録・編集・削除、ログインQRの配布</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 特徴 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">特徴</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-hierarchy-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">階層最上位の管理画面</h4>
                  <p className="text-gray-600 text-sm">組織全体を俯瞰できる管理機能</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-money-dollar-circle-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">財務管理</h4>
                  <p className="text-gray-600 text-sm">購入／寄付／キャンペーンの区別管理</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-qr-code-line text-xl text-purple-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">QRコードログイン</h4>
                  <p className="text-gray-600 text-sm">居場所管理者の認証を支援</p>
                </div>
              </div>
            </div>

            {/* 画面コンテンツ */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">画面コンテンツ</h3>
              <div className="grid md:grid-cols-2 gap-6">
                {adminFeatures.map((feature, index) => (
                  <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${feature.icon} text-lg text-blue-600`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">{feature.title}</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* アカウント作成について */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">アカウント作成について</h3>
              <div className="bg-blue-50 rounded-2xl p-8 border border-blue-200">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-add-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-blue-900 mb-3">初回利用時の手順</h4>
                    <p className="text-blue-700 mb-4">
                      初めてご利用になる場合、管理者アカウントを作成してから居場所の作成を行ってください。
                    </p>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h5 className="font-semibold text-blue-900 mb-2">管理者アカウントの作成</h5>
                      <p className="text-blue-700 text-sm mb-4">
                        管理者アカウントの作成は、ログイン選択画面の<strong>新規登録</strong>から行えます。
                      </p>
                      {/* 新規登録ボタンの位置を示す画像 */}
                      <div className="bg-white rounded-lg p-4 border border-blue-200">
                        <img
                          src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/831232b47082887fe13e3979ce7b84a4.png"
                          alt="新規登録ボタンの位置"
                          className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                        />
                        <p className="text-xs text-blue-600 text-center mt-2">
                          ログイン選択画面の新規登録ボタン
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h5 className="font-semibold text-blue-900 mb-2">居場所アカウントの作成</h5>
                      <p className="text-blue-700 text-sm mb-4">
                        居場所アカウントは管理者アカウントを作成後に管理画面の<strong>居場所管理タブ</strong>から新規登録を行えます。
                      </p>
                      {/* 居場所管理タブの画像 */}
                      <div className="bg-white rounded-lg p-4 border border-blue-200">
                        <img
                          src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/fecb98f654b1346112345bfd47a5dd5d.png"
                          alt="居場所管理タブでの新規登録"
                          className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                        />
                        <p className="text-xs text-blue-600 text-center mt-2">
                          管理画面の居場所管理タブから新規登録
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-blue-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-information-line text-blue-600 mt-1"></i>
                    <div>
                      <h5 className="font-semibold text-blue-900 mb-2">メールアドレスについて</h5>
                      <p className="text-blue-700 text-sm">
                        管理者アカウントと居場所アカウントは1つの居場所のみ同一のメールアドレスを使用できます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ポイントの購入と移動について */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">ポイントの購入と移動について</h3>
              <div className="bg-orange-50 rounded-2xl p-8 border border-orange-200">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-coin-line text-xl text-orange-600"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-orange-900 mb-3">ポイントの購入</h4>
                    <p className="text-orange-700 mb-4">
                      ポイントの購入は管理者画面の<strong>ポイント管理タブの購入タブ</strong>で行います。
                    </p>
                  </div>
                </div>

                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h5 className="font-semibold text-orange-900 mb-3">ポイントの購入</h5>
                      <p className="text-orange-700 text-sm mb-4">
                        ポイントの購入は管理者画面の<strong>ポイント管理タブの購入タブ</strong>で行います。
                      </p>

                      {/* ポイント購入画面の画像 */}
                      <div className="bg-white rounded-lg p-4 border border-orange-200 mb-4">
                        <img
                          src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/a0bb334e48b9e0ad7e6d8c84b3e397ce.png"
                          alt="ポイント購入画面"
                          className="w-full max-w-lg mx-auto rounded-lg shadow-sm"
                        />
                        <p className="text-xs text-orange-600 text-center mt-2">
                          ポイント管理タブの購入画面
                        </p>
                      </div>

                      <div className="bg-orange-100 rounded-lg p-4">
                        <h6 className="font-semibold text-orange-900 mb-2">購入手順</h6>
                        <ul className="text-orange-700 text-sm space-y-1">
                          <li>• ポイントは必要な時間分を選択しカートに追加します</li>
                          <li>• 10時間分を2つカートに入れると20時間分になります</li>
                          <li>• 必要な時間分を事前に購入してください</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h5 className="font-semibold text-orange-900 mb-3">ポイントの移動</h5>
                      <p className="text-orange-700 text-sm mb-4">
                        購入したポイントは、ポイント管理タブの<strong>ポイント移動ボタン</strong>で各居場所に分配と回収ができます。
                      </p>

                      <div className="bg-orange-100 rounded-lg p-4">
                        <h6 className="font-semibold text-orange-900 mb-2">移動手順</h6>
                        <ol className="text-orange-700 text-sm space-y-1">
                          <li>1. 作成した居場所を選択</li>
                          <li>2. 必要分のポイント数を入力</li>
                          <li>3. 分配or回収実行を押してください</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-orange-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-lightbulb-line text-orange-600 mt-1"></i>
                    <div>
                      <h5 className="font-semibold text-orange-900 mb-2">ポイント管理のコツ</h5>
                      <p className="text-orange-700 text-sm">
                        各居場所の利用状況を定期的に確認し、適切なポイント配分を行うことで効率的な運用が可能です。
                        誤配分した場合は回収機能を使用して調整できます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 操作方法 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">操作方法（基本の流れ）</h3>
              <div className="space-y-4">
                {adminSteps.map((step, index) => (
                  <div key={index} className="flex items-start gap-4 bg-gray-50 rounded-xl p-4">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {index + 1}
                    </div>
                    <p className="text-gray-700 pt-1">{step}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'place':
        return (
          <div className="space-y-12">
            {/* 目的・役割 */}
            <div className="bg-green-50 rounded-2xl p-8 border border-green-200">
              <h3 className="text-xl font-bold text-green-900 mb-4">目的・主な役割</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-green-800 mb-2">目的</h4>
                  <p className="text-green-700">学童等の現場で、学習者登録・セッション作成・進行管理・報告を行う</p>
                </div>
                <div>
                  <h4 className="font-semibold text-green-800 mb-2">主な役割</h4>
                  <ul className="text-green-700 space-y-1">
                    <li>• 学習者の登録・管理</li>
                    <li>• 個別／グループ／クラスの学習セッション作成</li>
                    <li>• 進行中セッションの状態確認、課題画像アップロード</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 特徴 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">特徴</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-group-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">3学習スタイル対応</h4>
                  <p className="text-gray-600 text-sm">個別/グループ/クラス</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-notification-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">リアルタイム通知</h4>
                  <p className="text-gray-600 text-sm">指導者からの提案をプッシュ通知で受信</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-wallet-line text-xl text-orange-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">債務管理</h4>
                  <p className="text-gray-600 text-sm">ポイント不足時の債務表示</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-file-text-line text-xl text-purple-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">学習報告書</h4>
                  <p className="text-gray-600 text-sm">学習報告書の作成機能</p>
                </div>
              </div>
            </div>

            {/* 画面コンテンツ */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">画面コンテンツ</h3>
              <div className="grid md:grid-cols-2 gap-6">
                {placeFeatures.map((feature, index) => (
                  <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${feature.icon} text-lg text-green-600`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">{feature.title}</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ログインについて */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">ログインについて</h3>
              <div className="bg-green-50 rounded-2xl p-8 border border-green-200">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-login-box-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-green-900 mb-3">ログイン方法</h4>
                    <p className="text-green-700 mb-4">
                      メールアドレスとパスワードログインとQRコードを使ってのログインが使用できます。
                    </p>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h5 className="font-semibold text-green-900 mb-2">メールアドレスとパスワードログイン</h5>
                      <p className="text-green-700 text-sm mb-4">
                        通常のメールアドレスとパスワードを使用したログイン方法です。
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h5 className="font-semibold text-green-900 mb-2">QRコードログイン</h5>
                      <p className="text-green-700 text-sm mb-4">
                        QRコードは、管理者用画面の居場所管理タブで発行したい居場所のQRコードボタンを押して発行できます。
                      </p>

                      {/* QRコード発行画面の画像 */}
                      <div className="bg-white rounded-lg p-4 border border-green-200">
                        <img
                          src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/fcd8a198d31ac9c122dd45070801e4f5.png"
                          alt="QRコード発行画面"
                          className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                        />
                        <p className="text-xs text-red-600 text-center mt-2 font-semibold">
                          ※画像は管理者用画面の画像です。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-green-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-information-line text-green-600 mt-1"></i>
                    <div>
                      <h5 className="font-semibold text-green-900 mb-2">ログイン方法の選択</h5>
                      <p className="text-green-700 text-sm">
                        QRコードログインは、パスワードを覚える必要がなく、簡単にアクセスできる便利な機能です。管理者から発行されたQRコードを使用してログインしてください。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 学習方法の選択について */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                  <i className="ri-settings-3-line text-white text-lg"></i>
                </div>
                学習方法の選択について
              </h3>

              <div className="space-y-8">
                {/* 個別セッション */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                      ①
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">個別セッション</h4>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    謲師と1対1で繋ぎオンラインで授業を行います。個別セッションが選択されている時は、学習を行う学習者をクリックして開始します。
                  </p>
                  <img
                    src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/4ce9bd4a57f3a2a74cd2a8065acc7bdc.png"
                    alt="個別セッションの画面"
                    className="w-full max-w-2xl rounded-lg shadow-sm border border-gray-200"
                  />
                </div>

                {/* グループ学習 */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                      ②
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">グループ学習</h4>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    謲師1名に対して複数の学習者がオンラインに入り授業を受けます。（複数名がオンラインに参加するには、人数分のスマホやＰＣ、タブレットが必要です）グループ学習が選択されている状態で、参加する学習者を選択し、グループ学習を作成のボタンを押します。
                  </p>
                  <img
                    src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/589d81c9151225f6947963f843a6e0fe.png"
                    alt="グループ学習の画面"
                    className="w-full max-w-2xl rounded-lg shadow-sm border-gray-200"
                  />
                </div>

                {/* クラス学習 */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                      ③
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">クラス学習</h4>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    1画面を複数の学習者で共有して、講師とオンライン授業を行う形式です。いつものプレイルームが学習教室に変わります。
                  </p>
                  <p className="text-gray-600 text-sm">
                    ※クラス学習の生徒選択方法はグループ学習と同様です。
                  </p>
                </div>
              </div>
            </div>

            {/* 学習の始め方について */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                  <i className="ri-play-circle-line text-white text-lg"></i>
                </div>
                学習の始め方について
              </h3>

              <div className="space-y-6">
                {/* ステップ1 */}
                <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ①
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-blue-900 mb-2">学習開始時間の選択</h4>
                    <p className="text-blue-700 leading-relaxed mb-4">
                      あとでを選択すると任意の時間を選べます。
                    </p>
                    {/* 学習開始時間選択の画像 */}
                    <div className="bg-white rounded-lg p-4 border border-blue-200">
                      <img
                        src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/5bddf24448281120ad46a147b57d6602.png"
                        alt="学習開始時間選択画面"
                        className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                      />
                      <p className="text-xs text-blue-600 text-center mt-2">
                        学習開始時間の選択画面
                      </p>
                    </div>
                  </div>
                </div>

                {/* ステップ2 */}
                <div className="flex items-start gap-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <div className="w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ②
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-green-900 mb-2">課題画像のアップロード</h4>
                    <p className="text-green-700 leading-relaxed mb-4">
                      学習者に指示された課題の画像をアップロードしてください。
                    </p>
                    <div className="bg-white rounded-lg p-4 border">
                      <img
                        src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/97069b3c73b42460d128964439d57b13.png"
                        alt="課題画像アップロード画面"
                        className="w-full max-w-md mx-auto rounded-lg"
                      />
                      <p className="text-xs text-green-600 text-center mt-2">
                        課題画像アップロード画面
                      </p>
                    </div>
                  </div>
                </div>

                {/* ステップ3 */}
                <div className="flex items-start gap-4 p-6 bg-orange-50 rounded-lg border border-orange-200">
                  <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ③
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-orange-900 mb-2">学習時間の承認</h4>
                    <p className="text-orange-700 leading-relaxed">
                      アップロードされた課題に対してボランティアから学習に必要な時間の提案が届きます。進行中のセッションに表示される内容を確認して承認を行ってください。
承認して予定時間になると授業開始ボタンが表示されます。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 操作方法 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">操作方法（基本の流れ）</h3>
              <div className="space-y-4">
                {placeSteps.map((step, index) => (
                  <div key={index} className="flex items-start gap-4 bg-gray-50 rounded-xl p-4">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {index + 1}
                    </div>
                    <p className="text-gray-700 pt-1">{step}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'volunteer':
        return (
          <div className="space-y-12">
            {/* 目的・役割 */}
            <div className="bg-purple-50 rounded-2xl p-8 border border-purple-200">
              <h3 className="text-xl font-bold text-purple-900 mb-4">目的・主な役割</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-purple-800 mb-2">目的</h4>
                  <p className="text-purple-700">時間とスキルのある時に、効率的に学習者への指導支援を行う</p>
                </div>
                <div>
                  <h4 className="font-semibold text-purple-800 mb-2">主な役割</h4>
                  <ul className="text-purple-700 space-y-1">
                    <li>• オンライン授業で学習支援</li>
                    <li>• セッション履歴の確認</li>
                    <li>• 獲得ポイントの換金申請</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 特徴 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">特徴</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-calendar-check-line text-xl text-purple-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">タイムラインマッチング</h4>
                  <p className="text-gray-600 text-sm">時間帯別の依頼、科目/学年/難易度/推定時間のフィルタ、AI解析結果の閲覧、授業時間選択</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-money-dollar-circle-line text-xl text-indigo-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">ポイント換金</h4>
                  <p className="text-gray-600 text-sm">指導時間に応じたポイントを換金可能</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-history-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">履歴管理</h4>
                  <p className="text-gray-600 text-sm">過去の指導履歴とフィードバックの確認</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-notification-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">通知機能</h4>
                  <p className="text-gray-600 text-sm">新しい依頼の通知受信</p>
                </div>
              </div>
            </div>

            {/* 画面コンテンツ */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">画面コンテンツ</h3>
              <div className="grid md:grid-cols-2 gap-6">
                {volunteerFeatures.map((feature, index) => (
                  <div key={index} className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${feature.icon} text-lg text-purple-600`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-2">{feature.title}</h4>
                        <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 操作方法 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">操作方法（基本の流れ）</h3>
              <div className="space-y-4">
                {volunteerSteps.map((step, index) => (
                  <div key={index} className="flex items-start gap-4 bg-gray-50 rounded-xl p-4">
                    <div className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">
                      {index + 1}
                    </div>
                    <p className="text-gray-700 pt-1">{step}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'video':
        return (
          <div className="space-y-12">
            {/* 目的・役割 */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-200">
              <h3 className="text-xl font-bold text-red-900 mb-4">目的・主な役割</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-red-800 mb-2">目的</h4>
                  <p className="text-red-700">オンライン学習セッションでのビデオ通話機能を効果的に活用する</p>
                </div>
                <div>
                  <h4 className="font-semibold text-red-800 mb-2">主な役割</h4>
                  <ul className="text-red-700 space-y-1">
                    <li>• ビデオ・マイク・画面の事前設定</li>
                    <li>• 通話中の各種機能操作</li>
                    <li>• 画面共有・背景設定の調整</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* ビデオ通話の操作方法 */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-red-500 rounded-lg flex items-center justify-center">
                  <i className="ri-video-line text-white text-lg"></i>
                </div>
                ビデオ通話の操作方法
              </h3>

              <div className="space-y-8">
                {/* ①ビデオ通話に参加する前に */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                      <i className="ri-apple-line text-white text-sm"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">ビデオ通話に参加する前に</h4>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    ビデオ・マイク・背景の設定ができます。
                  </p>
                </div>

                {/* ②ビデオ通話中の操作 */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                      <i className="ri-android-line text-white text-sm"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">ビデオ通話中の操作</h4>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    ビデオ通話中は、下部のボタンを操作して、左からビデオ・マイク・画面共有・背景ぼかし・画面分割・背景設定などの設定を変更する事ができます。
                  </p>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 mb-6">
                    <img
                      src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/3d8a378fab9ccca0eda487deb0d3d88f.png"
                      alt="ビデオ通話中の操作画面"
                      className="w-full max-w-2xl rounded-lg shadow-sm border border-gray-200"
                    />
                    <p className="text-xs text-gray-600 text-center mt-2">
                      ビデオ通話中の操作画面
                    </p>
                  </div>

                  {/* 画面分割設定の補足説明 */}
                  <div className="bg-blue-50 rounded-lg p-4 border border-blue-200 mb-4">
                    <h5 className="font-semibold text-blue-900 mb-2">画面分割設定について</h5>
                    <p className="text-blue-700 text-sm mb-4">
                      画面分割機能を使用することで、参加者の表示方法を調整できます。
                    </p>
                    <div className="bg-white rounded-lg p-4 border border-blue-200">
                      <img
                        src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/2f90356a78ac8d0b01606f2ca6f42dd0.png"
                        alt="画面分割設定画面"
                        className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                      />
                      <p className="text-xs text-blue-600 text-center mt-2">
                        画面分割設定画面
                      </p>
                    </div>
                  </div>

                  {/* 背景設定の補足説明 */}
                  <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                    <h5 className="font-semibold text-green-900 mb-2">背景設定について</h5>
                    <p className="text-green-700 text-sm mb-4">
                      背景設定機能では、背景ぼかしや背景画像の変更ができます。
                    </p>
                    <div className="bg-white rounded-lg p-4 border border-green-200">
                      <img
                        src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/d6c374cf8d009c1848ad7d84fbc2807f.png"
                        alt="背景設定画面"
                        className="w-full max-w-md mx-auto rounded-lg shadow-sm"
                      />
                      <p className="text-xs text-green-600 text-center mt-2">
                        背景設定画面
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 特徴 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">特徴</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-settings-3-line text-xl text-red-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">事前設定機能</h4>
                  <p className="text-gray-600 text-sm">通話前にビデオ・マイク・背景を調整可能</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-share-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">画面共有</h4>
                  <p className="text-gray-600 text-sm">学習資料や課題を共有して効果的な指導</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-image-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">背景設定</h4>
                  <p className="text-gray-600 text-sm">背景ぼかしや背景変更で集中しやすい環境</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'notification':
        return (
          <div className="space-y-12">
            {/* 目的・役割 */}
            <div className="bg-teal-50 rounded-2xl p-8 border border-teal-200">
              <h3 className="text-xl font-bold text-teal-900 mb-4">目的・主な役割</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-teal-800 mb-2">目的</h4>
                  <p className="text-teal-700">スマートフォンでプッシュ通知を受け取り、重要な情報をリアルタイムで確認する</p>
                </div>
                <div>
                  <h4 className="font-semibold text-teal-800 mb-2">主な役割</h4>
                  <ul className="text-teal-700 space-y-1">
                    <li>• PWAアプリのインストール</li>
                    <li>• プッシュ通知の許可設定</li>
                    <li>• 通知の受信と確認</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* PWAとは */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className="ri-smartphone-line text-white text-lg"></i>
                </div>
                PWA（Progressive Web App）とは
              </h3>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  PWAは、Webサイトをスマートフォンのように使える技術です。アプリストアからダウンロードする必要がなく、ブラウザから直接ホーム画面に追加できます。
                </p>
                <div className="bg-teal-50 rounded-lg p-4 border border-teal-200">
                  <h4 className="font-semibold text-teal-900 mb-2">PWAの特徴</h4>
                  <ul className="text-teal-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 mt-1"></i>
                      <span>ストアからのダウンロード不要</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 mt-1"></i>
                      <span>ホーム画面から直接起動可能</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 mt-1"></i>
                      <span>プッシュ通知の受信が可能</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-600 mt-1"></i>
                      <span>オフラインでも一部機能が利用可能</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* iPhoneでのPWAインストール方法 */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
                  <i className="ri-apple-line text-white text-lg"></i>
                </div>
                iPhoneでのPWAインストール方法
              </h3>

              <div className="space-y-6">
                {/* ステップ1 */}
                <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ①
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-blue-900 mb-2">Safariでサイトを開く</h4>
                    <p className="text-blue-700 leading-relaxed mb-4">
                      iPhoneの標準ブラウザ「Safari」でサイトにアクセスしてください。
                    </p>
                    <div className="bg-yellow-50 rounded-lg p-3 border border-yellow-200">
                      <p className="text-yellow-800 text-sm flex items-start gap-2">
                        <i className="ri-alert-line text-yellow-600 mt-0.5"></i>
                        <span>注意：Chrome等の他のブラウザではPWAのインストールができません。必ずSafariを使用してください。</span>
                      </p>
                    </div>
                  </div>
                </div>

                {/* ステップ2 */}
                <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ②
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-blue-900 mb-2">共有ボタンをタップ</h4>
                    <p className="text-blue-700 leading-relaxed mb-4">
                      画面下部の共有ボタン（四角に上向き矢印のアイコン）をタップします。
                    </p>
                  </div>
                </div>

                {/* ステップ3 */}
                <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ③
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-blue-900 mb-2">「ホーム画面に追加」を選択</h4>
                    <p className="text-blue-700 leading-relaxed mb-4">
                      表示されるメニューから「ホーム画面に追加」を選択します。
                    </p>
                  </div>
                </div>

                {/* ステップ4 */}
                <div className="flex items-start gap-4 p-6 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ④
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-blue-900 mb-2">追加を確定</h4>
                    <p className="text-blue-700 leading-relaxed mb-4">
                      名前を確認して「追加」をタップします。ホーム画面にアイコンが追加されます。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* AndroidでのPWAインストール方法 */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                  <i className="ri-android-line text-white text-lg"></i>
                </div>
                AndroidでのPWAインストール方法
              </h3>

              <div className="space-y-6">
                {/* ステップ1 */}
                <div className="flex items-start gap-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <div className="w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ①
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-green-900 mb-2">Chromeでサイトを開く</h4>
                    <p className="text-green-700 leading-relaxed mb-4">
                      Google Chromeブラウザでサイトにアクセスしてください。
                    </p>
                  </div>
                </div>

                {/* ステップ2 */}
                <div className="flex items-start gap-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <div className="w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ②
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-green-900 mb-2">メニューを開く</h4>
                    <p className="text-green-700 leading-relaxed mb-4">
                      画面右上の3点メニュー（︙）をタップします。
                    </p>
                  </div>
                </div>

                {/* ステップ3 */}
                <div className="flex items-start gap-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <div className="w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ③
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-green-900 mb-2">「ホーム画面に追加」を選択</h4>
                    <p className="text-green-700 leading-relaxed mb-4">
                      メニューから「ホーム画面に追加」または「インストール」を選択します。
                    </p>
                  </div>
                </div>

                {/* ステップ4 */}
                <div className="flex items-start gap-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <div className="w-10 h-10 bg-green-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ④
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-green-900 mb-2">インストールを確定</h4>
                    <p className="text-green-700 leading-relaxed mb-4">
                      「インストール」または「追加」をタップします。ホーム画面にアイコンが追加されます。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* プッシュ通知の設定方法 */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                  <i className="ri-notification-line text-white text-lg"></i>
                </div>
                プッシュ通知の設定方法
              </h3>

              <div className="space-y-6">
                {/* ステップ1 */}
                <div className="flex items-start gap-4 p-6 bg-orange-50 rounded-lg border border-orange-200">
                  <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ①
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-orange-900 mb-2">PWAを起動</h4>
                    <p className="text-orange-700 leading-relaxed mb-4">
                      ホーム画面に追加したアイコンをタップして起動します。
                    </p>
                  </div>
                </div>

                {/* ステップ2 */}
                <div className="flex items-start gap-4 p-6 bg-orange-50 rounded-lg border border-orange-200">
                  <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ②
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-orange-900 mb-2">通知許可のポップアップを確認</h4>
                    <p className="text-orange-700 leading-relaxed mb-4">
                      初回起動時または通知設定画面で、通知の許可を求めるポップアップが表示されます。
                    </p>
                  </div>
                </div>

                {/* ステップ3 */}
                <div className="flex items-start gap-4 p-6 bg-orange-50 rounded-lg border border-orange-200">
                  <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0">
                    ③
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-orange-900 mb-2">「許可」を選択</h4>
                    <p className="text-orange-700 leading-relaxed mb-4">
                      通知を受け取るために「許可」または「OK」をタップします。
                    </p>
                    <div className="bg-yellow-50 rounded-lg p-3 border border-yellow-200">
                      <p className="text-yellow-800 text-sm flex items-start gap-2">
                        <i className="ri-alert-line text-yellow-600 mt-0.5"></i>
                        <span>注意：「許可しない」を選択すると、プッシュ通知を受け取れません。後から設定を変更する場合は、スマートフォンの設定から変更する必要があります。</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 通知設定の変更方法 */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-8 h-8 bg-purple-500 rounded-lg flex items-center justify-center">
                  <i className="ri-settings-line text-white text-lg"></i>
                </div>
                通知設定の変更方法
              </h3>

              <div className="space-y-8">
                {/* iPhone */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                      <i className="ri-apple-line text-white text-sm"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">iPhone（iOS）の場合</h4>
                  </div>
                  <ol className="text-gray-700 space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-blue-600 flex-shrink-0">1.</span>
                      <span>「設定」を開く</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-blue-600 flex-shrink-0">2.</span>
                      <span>「通知」を選択</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-blue-600 flex-shrink-0">3.</span>
                      <span>一覧から該当のものを選択</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-blue-600 flex-shrink-0">4.</span>
                      <span>「通知を許可」をオン/オフで切り替え</span>
                    </li>
                  </ol>
                </div>

                {/* Android */}
                <div className="border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                      <i className="ri-android-line text-white text-sm"></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">Androidの場合</h4>
                  </div>
                  <ol className="text-gray-700 space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-green-600 flex-shrink-0">1.</span>
                      <span>「設定」を開く</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-green-600 flex-shrink-0">2.</span>
                      <span>「通知」を選択</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-green-600 flex-shrink-0">3.</span>
                      <span>該当のものを選択</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="font-semibold text-green-600 flex-shrink-0">4.</span>
                      <span>「通知」を選択し、オン/オフで切り替え</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>

            {/* 通知の種類 */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-6">受け取れる通知の種類</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-user-heart-line text-xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">ボランティアからの提案</h4>
                  <p className="text-gray-600 text-sm">学習セッションに対するボランティアからの指導提案が届きます</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-calendar-check-line text-xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">セッション開始のリマインダー</h4>
                  <p className="text-gray-600 text-sm">予定されているセッションの開始時刻が近づくと通知されます</p>
                </div>
              </div>
            </div>

            {/* トラブルシューティング */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-200">
              <h3 className="text-xl font-bold text-red-900 mb-6 flex items-center gap-3">
                <i className="ri-error-warning-line text-2xl text-red-600"></i>
                トラブルシューティング
              </h3>
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-red-900 mb-2">通知が届かない場合</h4>
                  <ul className="text-red-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>スマートフォンの通知設定で通知が許可されているか確認</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>スマートフォンがインターネットに接続されているか確認</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>PWAを一度終了して再起動してみる</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>スマートフォンの「おやすみモード」や「集中モード」がオフになっているか確認</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-red-900 mb-2">PWAがインストールできない場合</h4>
                  <ul className="text-red-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>iPhoneの場合：必ずSafariブラウザを使用しているか確認</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>Androidの場合：Google Chromeブラウザを使用しているか確認</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line text-red-600 mt-1"></i>
                      <span>ブラウザのバージョンが最新か確認し、必要に応じて更新</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-white noto-sans-jp-manual">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap');
        .noto-sans-jp-manual {
          font-family: "Noto Sans JP", sans-serif;
          font-optical-sizing: auto;
        }
      `}</style>
      <Header />

      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">操作マニュアル</h1>
          <p className="text-lg text-gray-600 mb-8">役割ごとに基本機能と使い方を説明します（公開版）</p>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>
      </section>

      {/* Tab Section */}
      <section className="px-4 pb-16">
        <div className="max-w-4xl mx-auto">
          {/* Tabs */}
          <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-t-lg font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'bg-blue-500 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="tab-content">{renderTabContent()}</div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
